"use client";

import React from "react";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="252651" id="cta-section" className="bg-foreground py-20 md:py-28 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-primary/10 blur-[120px]"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/5 blur-[120px]"></div>
      </div>

      <div ref={ref} className={`page-container relative z-10 flex flex-col items-center text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-lg bg-primary/10 mb-8">
          <ShieldCheck className="w-10 h-10 text-primary" />
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-background mb-6 font-default max-w-3xl leading-tight">
          지금 바로 입학 지원을 시작하세요
        </h2>

        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-10 font-default leading-relaxed">
          AI 검색 최적화 상태를 정확히 파악하고 개선 방안을 확인하세요. 
          조이봇지오의 인사이트로 비즈니스 성장을 가속화할 수 있습니다.
        </p>

        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-14 px-8 rounded-md shadow-lg shadow-primary/20 group">
          <Link to="/HomePage">
            입학 지원하기
            <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      </div>
    </section>;
}